export default __webpack_public_path__ + "static/media/dome9-long.9286295c.png";